<template>
    <div class="unsubscribe-page">
        <Logo class="unsubscribe-page__logo"/>
        <div class="unsubscribe-page__card">

            <template v-if="unsubscribeSuccess">
                <div class="unsubscribe-page__card-title">
                    退订成功。
                </div>
                <div class="unsubscribe-page__card-body">
                    <p class="unsubscribe-page__p">
                        您将不再收到AirFunc Blog有关新博客发布的电子邮件。
                    </p>
                </div>
            </template>
            <template v-else>
                <div class="unsubscribe-page__card-title">
                    很抱歉看到您的退订。
                </div>
                <div class="unsubscribe-page__card-body">
                    <p class="unsubscribe-page__p">
                        您将不再收到AirFunc Blog有关新博客发布的电子邮件。
                    </p>
                </div>
                <div class="unsubscribe-page__card-footer">
                    <app-button class="unsubscribe-page__button"
                                :disabled="disabled"
                                @click="handleUnsubscribeClick">
                        <app-loading v-if="loading"/>
                        <template v-else>
                            退订
                        </template>
                    </app-button>
                </div>
                <p class="unsubscribe-page__error-message">
                    {{errorMsg}}
                </p>
            </template>


        </div>
    </div>
</template>

<script>
    import AppButton from '@components/AppButton'
    import AppLoading from '@components/AppLoading'
    import Logo from '@assets/svg/inline.logo.svg'

    import unsubscribeService from '@service/unsubscribeService'

    export default {
        name: "Subscribe",
        data() {
            return {
                loading: false,
                errorMsg: '',
                unsubscribeSuccess: false
            }
        },
        computed: {
            id() {
                return this.$route.query.subscribe
            },
            disabled() {
                const {loading, id} = this
                return !id || loading
            }
        },
        watch: {
            id: {
                handler(val) {
                    if (!val) {
                        this.errorMsg = '退订链接不存在或已取消订阅。'
                    } else {
                        this.errorMsg = ''
                    }
                },
                immediate: true
            }
        },
        methods: {
            handleUnsubscribeClick() {
                const {disabled, id} = this
                if (!disabled) {
                    this.unsubscribe(id)
                }
            },
            async unsubscribe(id) {
                try {
                    this.loading = true
                    await unsubscribeService({id})
                    this.errorMsg = ''
                    this.unsubscribeSuccess = true
                } catch (e) {
                    this.errorMsg = e.message === '记录不存在' ? '退订链接不存在或已取消订阅。' : e.message
                } finally {
                    this.loading = false
                }
            }
        },
        components: {
            AppButton,
            Logo,
            AppLoading
        }
    }
</script>

<style lang="scss">
    @import "@assets/styles/varibles.scss";
    @import "@assets/styles/mixins.scss";

    .unsubscribe-page {
        padding: $paddingSP;
        padding-top: 70px;
        color: $textColor;
        color: var(--textColor);
        @include transition-colors;

        &__logo {
            width: 150px;
            margin: 0 auto $paddingSP;
        }

        &__card {
            max-width: 600px;
            margin: 0 auto;
            padding: $paddingMD;
            // background-color: $darkComponentBackgroundColor;
            // border-radius: $radius;

            &-title {
                font-size: $fontSizeLG;
                font-weight: $fontWeightBolder;
                margin-bottom: $paddingLG;
            }
        }

        &__p {
            font-size: $fontSize;
            line-height: 2;
            margin-bottom: $paddingMD;
        }

        &__card-footer {
            margin-top: $paddingLG;
            text-align: center;
        }

        &__button {
            display: inline-block;
            padding: $paddingBase $paddingMD;
            border-radius: $radius;
            color: #fff;
            background-color: $darkPrimaryColor;

            &:hover {
                color: #fff;
                background-color: $primaryColor;
            }
        }

        &__error-message {
            color: $primaryColor;
            color: var(--primaryColor);
            @include transition-colors;
        }

        .app-loading {
            padding: 0;
            height: 22px;
        }
    }
</style>